export default __webpack_public_path__ + "static/media/Bloodsap.9f488cc7.jpg";